import type { Distance, SpatialRectangle } from "@pdfking/math"
import { Min, Scale, Subtract, Total } from "@pdfking/math"

// A plate `ratio` wide to its height centered on `center` across, as big as
// fits between `top` and `bottom` and `max_width` wide, centered between them
// too
export const PlateBox = ({
  bottom,
  center,
  max_width,
  ratio,
  top,
}: {
  bottom: Distance
  center: Distance
  max_width: Distance
  ratio: number
  top: Distance
}): SpatialRectangle<Distance> => {
  const width = Min(max_width, Scale(Subtract(top, bottom), ratio))
  const height = Scale(width, 1 / ratio)
  return {
    height,
    width,
    x: Subtract(center, Scale(width, 0.5)),
    y: Scale(Subtract(Total(top, bottom), height), 0.5),
  }
}
